<template lang="html">
    <div
        v-md
        class="changelog-wrap"
    >
    {{text}}
    </div>
</template>
<script>
import changelog from '../../../CHANGELOG.md'

export default {
  created () {
    this.text = changelog
  },

  data () {
    return {
      text: ''
    }
  }
}
</script>
<style lang="scss" scpoed>
    .changelog-wrap {
        padding: 40px;
    }
</style>
